import { useCallback } from 'react';
import { getConfigValue } from '@zonofi/common';

const GOOGLE_MAP_API_KEY = getConfigValue('GOOGLE_MAP_API_KEY');
export const useGoogleAddress = () => {
  const fetchLocation = useCallback(
    async (lat: number, lng: number): Promise<string> => {
      let fullAddress = '';
      try {
        const response = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&location_type=ROOFTOP&result_type=street_address&key=${GOOGLE_MAP_API_KEY}`
        );
        const res = await response.json();
        if (res.results.length > 0) {
          fullAddress = res.results[0].formatted_address;
        } else {
          throw new Error('No results found');
        }
      } catch (error) {
        console.error(error);
      }
      return fullAddress;
    },
    []
  );

  const getLocation = useCallback(async (lat: number, lng: number) => {
    const address = await fetchLocation(lat, lng);
    return address;
  }, []);

  return {
    getLocation,
  };
};
